export default `attribute float aSeed;
attribute float aBright;
attribute float aT; 
attribute float aKeep; 

uniform float uTime;
uniform float uSize;
uniform float uScale;
uniform float uPixelRatio;
uniform float uReveal;
uniform float uGlyphCount;
uniform float uFlowSpeed;
uniform float uYOffset; 
uniform float uDensity; 

varying float vGlyph;
varying float vBright;
varying float vAlpha;

void main() {
  
  if (aKeep > uDensity) {
    gl_Position = vec4(2.0, 2.0, 2.0, 1.0);
    gl_PointSize = 0.0;
    return;
  }

  vec3 pos = position;
  pos.y += uYOffset + sin(uTime * 0.8 + aSeed * 30.0) * 0.05; 

  vec4 mv = modelViewMatrix * vec4(pos, 1.0);
  gl_Position = projectionMatrix * mv;
  gl_PointSize = uSize * uPixelRatio * (uScale / max(-mv.z, 0.1));

  
  float flow = 0.5 + 0.5 * sin(aT * 42.0 - uTime * uFlowSpeed + aSeed * 2.0);
  vBright = clamp(aBright * 0.55 + flow * 0.55, 0.0, 1.0);
  vGlyph = floor(vBright * (uGlyphCount - 1.0) + 0.5);
  vAlpha = uReveal * (0.35 + 0.65 * flow);
}`